import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { Document } from '@roc/feature-types';
import { makeStyles } from '@material-ui/core/styles';
import { InsuranceInformationBaseStore, InsuranceInformationReviewBaseStore } from '@roc/feature-insurance-review';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { InsuranceInformationAndReview } from './insuranceInformationAndReview';

export type InsuranceInformationAndReviewDialogProps = {
  open?: boolean;
  onClose?: () => void;
  document: Document;
  insuranceInformationStore: InsuranceInformationBaseStore;
  insuranceInformationReviewStore: InsuranceInformationReviewBaseStore;
  loanId: string;
};

const useStyles = makeStyles(theme => ({
  dialogPadding: {
    '& .MuiDialogContent-root': {
      padding: '0 24px',
    },
    '& .MuiDialogTitle-root': {
      paddingBottom: 0
    }
  }
}));

export const InsuranceInformationAndReviewDialog = observer(
  (props: InsuranceInformationAndReviewDialogProps) => {
    const { open, onClose, insuranceInformationStore, insuranceInformationReviewStore, loanId, document } = props;
    const taskId = document?.taskId;
    const classes = useStyles();

    const getContent = () => {
      return (
        <InsuranceInformationAndReview
          insuranceInformationStore={insuranceInformationStore}
          insuranceInformationReviewStore={insuranceInformationReviewStore}
          loanId={loanId}
          document={document}
          handleClose={onClose}
        />
      );
    }

    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            className={classes.dialogPadding}
            open={open}
            title={'Insurance Information'}
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={getContent()}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            className={classes.dialogPadding}
            open={open}
            maxWidth="lg"
            handleClose={onClose}
            dialogContent={getContent()}
          />
        )}
      </>
    );
  }
);
